import { Component, OnInit } from "@angular/core";
import { AuthService } from "../auth-service.service";

@Component({
    selector: "ngx-login",
    templateUrl: "./login.component.html",
    styleUrl: "./login.component.scss",
    standalone: true,
})
/**
 * Login screen; on load it checks the Auth0 auth state and redirects to the
 * identity provider or restores an existing session as appropriate.
 */
export class LoginComponent implements OnInit {
  constructor(private authService: AuthService) {}

  /** Lifecycle hook that triggers the Auth0 session check/redirect. */
  ngOnInit(): void {
    this.authService.checkAuthState();
  }
}
